export enum DEPARTMENTS {
	CM = 1,
	HA = 2,
	MU = 3,
	LOC = 4,
	SET = 5,
	PR = 6,
}

export enum GENDERS {
	NONE,
	MALE,
	FEMALE,
	NON_BINARY,
}

export enum INT_EXT {
	INT = 1,
	EXT,
	INT_EXT,
	EXT_INT,
}

export enum ITEM_TYPES {
	CLOTHING = 1,
	ACCESSORY,
	FOOTWEAR,
}

export enum PURCHASE_TYPES {
	BUY = 1,
	RENT,
	MTO,
	PROMO,
	KIT = 10,
}

export enum SCRIPT_OVERRIDES {
	PDF = 1,
	XML,
	FOX_XML,
}

export enum SET_TYPES {
	LOCATION = 1,
	SWING,
	STANDING,
}

export enum DISPOSITIONS {
	OTHER = 1,
	APPROVED_SALE,
	TRANSFER,
	STORAGE,
	APPROVED_LOAN,
	APPROVED_DONATION,
	LOSS_DAMAGE,
	EXPENDABLES_CONSUMED,
	DESTROYED,
}

export enum FIELD_TYPES {
	DATE,
	INPUT,
	NUMBER,
	CURRENCY,
	SELECT,
	MULTISELECT,
	CHECKBOX,
	COMBO,
	TEXTAREA,
	CREATE_SELECT,
	SCRIPT_DAY,
	SCRIPT_LOCATION,
	TIME,
	PHOTO,
}

export enum SHOOT_TIMES {
	D = 1,
	N,
	DAWN,
	DUSK,
}

export enum UNITS {
	MAIN = 1,
	SECOND,
	SPLINTER,
	PLATE,
	AERIAL,
	UNDERWATER,
	MOUNTAIN,
	STILL_SHOOT,
	VISUAL_EFFECTS,
}

export enum EditStateType {
	EditAll = 1,
	Cancel,
	Save,
	None,
}

export enum TableType {
	Inventory = 1,
	Scene,
	Character,
	Actor,
	WrapBox,
	None,
}

export enum CreateEditModalTypes {
	Create = 'Create',
	Edit = 'Edit',
}

export enum CHARACTER_TYPE {
	BACKGROUND,
	PRINCIPAL,
}

export enum TableStyleType {
	CM = 1,
	HA,
	MU,
	INV,
	PR,
	SET,
	CHAR,
	SCENE,
	WRAP,
	ACTOR,
}

export enum WRAP_BOX_VIEWS {
	Change = 0,
	Character,
}

export enum COLORS {
	ACTORS = '#F4C84B',
	CHANGE_LIGHT = '#D3BEE5',
	CHARACTERS_LIGHT = '#BEE2DF',
	CHARACTERS = '#7DC5BF',
	CONTINUITY_BLUE = '#329CF5',
	COSTUME = '#B188D4',
	HAIR_LIGHT = '#FCE3BB',
	HAIR = '#FAC878',
	INVENTORY_LIGHT = '#B3CFEE',
	INVENTORY = '#689FDE',
	MAKEUP_LIGHT = '#F3BFC4',
	MAKEUP = '#E78089',
	PROPS = '#689FDE',
	PERSONAL_PROP_STAR = '#7ED321',
	PLACEHOLDER = '#D8D8D8',
	SCENES_LIGHT = '#E9B1CD',
	SCENES = '#D4639C',
	SET_DEC = '#B0C95E',
	SET_LIGHT = '#D7E4AE',
	SOS = '#F4C84B',
	WRAPBOX = '#6868DE',
}

export enum PRODUCTS {
	CONTINUITY = 'Continuity',
	PR_BUDGET = 'Prop Budget',
	CM_BUDGET = 'Costume Budget',
	SET_BUDGET = 'Set Dec Budget',
}

export enum ACTIVITY_TYPES {
	ACTIVITY_FEED = 'activity_feed',
	CHANGES = 'changes',
	CHANGE_SCENES = 'change_scenes',
	CHAR_SCENES = 'char_scenes',
	CM_PERMISSIONS = 'cm_permissions',
	DELETED = 'deleted',
	EPISODIC_ACTORS = 'episodic_actors',
	EPISODIC_CHARACTERS = 'episodic_characters',
	EPISODIC_ITEMS = 'episodic_items',
	EPISODIC_PROPS = 'episodic_props',
	HA_CHANGES = 'ha_changes',
	HA_CHANGE_SCENES = 'ha_change_scenes',
	HA_PERMISSIONS = 'ha_permissions',
	MU_CHANGES = 'mu_changes',
	MU_CHANGE_SCENES = 'mu_change_scenes',
	MU_PERMISSIONS = 'mu_permissions',
	NEW_PROD = 'new_prod',
	PERMISSIONS = 'permissions',
	PICTURES = 'pictures',
	PROD_PERMISSIONS = 'prod_permissions',
	PROP_SCENES = 'prop_scenes',
	PR_PERMISSIONS = 'pr_permissions',
	SCENES = 'scenes',
	SETS = 'sets',
	SET_PERMISSIONS = 'set_permissions',
	SET_PIECES = 'set_pieces',
}

export enum REPORT_TYPES {
	PDF = 1,
	CSV,
}

export enum PICTURE_TYPES {
	PICTURE_SCENE = 1,
	CM_CHANGE_PICTURE,
	EPISODIC_CHARACTER_PICTURE,
	CM_EPISODIC_ITEM_PICTURE,
	PR_EPISODIC_PROP_PICTURE,
	SET_PIECE_PICTURE,
	HA_LOOK_PICTURE,
	MU_LOOK_PICTURE,
}

export enum PLANS {
	FREE = 0,
	STANDARD,
	PREMIUM,
	LITE,
}

export enum MERGE_STEPS {
	INTRO = 1,
	SAVE,
	CANCEL_CONFIRM,
	HAS_RESOLVABLE_CONFLICTS,
	HAS_UNRESOLVABLE_CONFLICTS,
	RESOLVABLE_NAME,
	RESOLVABLE_MONEY_TRACKING_GROUP,
	RESOLVED_SAVE,
	UNRESOLVABLE_ACTOR,
	UNRESOLVABLE_GENDER,
	UNRESOLVABLE_AGE,
	UNRESOLVABLE_CHAR_NUM_BY_PROD,
	UNRESOLVABLE_BUDGET_CHARACTER,
	UNRESOLVABLE_DESCRIPTION,
	UNRESOLVABLE_CHAR_COUNT,
	UNRESOLVABLE_CHANGE_SCENE,
	UNRESOLVABLE_BG_COUNTS,
	FORBIDDEN_DEPTS,
	UNRESOLVABLE_CM_EP_CHAR_NOTE,
	UNRESOLVABLE_HA_EP_CHAR_NOTE,
	UNRESOLVABLE_MU_EP_CHAR_NOTE,
	UNRESOLVABLE_PR_EP_CHAR_NOTE,
}

export enum EPISODIC_FLAG_TYPES {
	CHAR_MERGE = 1,
}

export enum NAVIGATING_FROM {
	CHANGE_VIEW = 'ChangeView',
	CHARACTER_VIEW = 'CharacterView',
}

export enum ALL_ITEM_REPORT_QUERY_TYPES {
	ALL_CHARACTERS = 'All Characters',
	PRINCIPALS_ONLY = 'Principals Only',
	BACKGROUND_ONLY = 'Background Only',
	SELECT_CHARACTERS = 'Select Characters',
}

export enum CHARACTER_REPORT_QUERY_TYPES {
	ALL_CHARACTERS = 'All Characters',
	PRINCIPALS_ONLY = 'Principals Only',
	BACKGROUND_ONLY = 'Background Only',
	SELECT_CHARACTERS = 'Select Characters',
}

export enum ALL_PROPS_REPORT_SORT_TYPES {
	COST = 'Sort by Total Cost',
	NAME = 'Sort by Name',
	CATEGORY = 'Sort by Category',
	CHARACTER = 'Sort by Character',
}

export enum PROPS_ASSETS_REPORT_SORT_TYPES {
	NAME = 'SortByName',
	CHARACTER = 'SortByCharacter',
}

export enum INCLUDE_PHOTO_OPTIONS {
	NONE,
	INVENTORY,
	MAIN,
}

export enum BannerType {
	FREE_TRIAL,
	EXPIRY_NOTICE,
	REPORTS_TOGGLE,
}

export enum COSTUME_WRAP_BOX_OPTIONS {
	name = 1,
	asset,
	brand,
	categoryOrType,
	color,
	description,
	disposition,
	dispositionNotes,
	endDate,
	purchaseType,
	quantity,
	size,
	skuOrBarcode,
	startDate,
	status,
	storageLocation,
	totalCost,
	unitPrice,
	vendor,
}
